export const BREAKPOINTS = {
  LARGE: 1600,
  DESKTOP: 1200,
  LAPTOP: 992,
  TABLET: 768,
  PHONE: 576,
}
